import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  gpathSession: cacheLs.get_gpath_session()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
